import type { ReactNode } from 'react'
import { Button } from '@/components/Button'
import { Segmented } from '@/components/Segmented'
import {
  PaneBody,
  PaneTools,
} from '@/features/jobs/details/components/JobSections/Pane'
import styles from './IntakePane.module.css'
import { type IntakePaneTab } from '@/features/jobs/details/JobCapturedInformationViewModel'

export interface IntakePaneProps<T extends string> {
  tabs: IntakePaneTab<T>[]
  currentTab: T
  onTabChange: (tab: T) => void
  showEditResponses: boolean
  onEditResponses: () => unknown
  children: ReactNode
}

/**
 * Everything the client's questionnaire captured: the answers, grouped by the
 * questionnaire's own sections, and the profiles, refund details and
 * instructions it collected along the way.
 */
export function IntakePane<T extends string>({
  tabs,
  currentTab,
  onTabChange,
  showEditResponses,
  onEditResponses,
  children,
}: IntakePaneProps<T>) {
  return (
    <>
      {(tabs.length > 1 || showEditResponses) && (
        <PaneTools>
          {tabs.length > 1 && (
            <Segmented
              options={tabs}
              value={currentTab}
              onChange={onTabChange}
            />
          )}
          <span className={styles.spacer} />
          {showEditResponses && (
            <Button
              label="Edit responses"
              size="small"
              onPress={onEditResponses}
              testId="captured-information-card-edit-responses-button"
            />
          )}
        </PaneTools>
      )}
      <PaneBody>
        <div className={styles.root}>{children}</div>
      </PaneBody>
    </>
  )
}
